module.exports = __webpack_public_path__ + "img/text-paragraph.9f1672e1.svg";